import { render, staticRenderFns } from "./account-start.vue?vue&type=template&id=0035566e&scoped=true&"
import script from "./account-start.vue?vue&type=script&lang=js&"
export * from "./account-start.vue?vue&type=script&lang=js&"
import style0 from "./account-start.vue?vue&type=style&index=0&id=0035566e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0035566e",
  null
  
)

export default component.exports